import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

declare var $: any;
import * as moment from 'moment';
import {Priorities, Statuses, Task} from "../../../entities/Task";
import {ResourceTaskTime} from "../../../entities/ResourceTaskTime";
import {TimeplanService} from "../../../services/timeplan.service";
import {Resource} from "../../../entities/Resource";
import {environment} from "../../../../environments/environment";
import {Calendar, CalendarFilter} from "../../../entities/Calendar";
import {Observable} from "rxjs/Observable";
import {TaskService} from "../../../services/task.service";
import {Job} from "../../../entities/Job";
import {TaskPageModel, TaskTypes, ViewNames} from "../../../entities/PageModel";
import {ResourceTaskTimeService} from "../../../services/resource-task-time.service";
import {IMyDpOptions, IMyDateModel} from "mydatepicker";
import {ApproveEventsModel} from "../../../entities/ApproveEventsModel";
import {Router} from "@angular/router";
import {resource} from "selenium-webdriver/http";


@Component({
  selector: 'app-scheduler-view',
  templateUrl: './scheduler-view.component.html',
  styleUrls: ['./scheduler-view.component.css']
})

export class SchedulerViewComponent implements OnInit {

  @Input()
  calendar: Calendar = null;

  @Input()
  unPlannedTasks: TaskPageModel;
  @Input()
  plannedTasks: TaskPageModel;

  @Input()
  employees: Resource[];
  @Input()
  employeeEvents: ResourceTaskTime[];
  @Input()
  calendarDate: string;
  @Input()
  firstRun: Boolean;

  @Input()
  ChosenJob: Job;

  _ChosenTask: Task;


  resourceGroups: any[];

  //@Input()
  //Jobs : Job[];

  @Input()
  JobTasks: Task[];

  @Input()
  ChosenTaskRef: string;

  @Input()
  isAdmin: boolean;


  @Output()
  updateTaskEmitter = new EventEmitter();

  @Output()
  setEmployeeEmitter = new EventEmitter();

  @Output()
  getTaskEmitter = new EventEmitter();

  @Output()
  updateTimePlanEmitter = new EventEmitter();

  @Output()
  updateRTTEmitter = new EventEmitter();

  @Output()
  removeEmpTimePlanEmitter = new EventEmitter();

  @Output()
  changeJobTaskEmitter = new EventEmitter();

  @Output()
  refreshCurrentTaskListEmitter = new EventEmitter();

  @Output()
  SetApprovedOnCurrentEventsEmitter = new EventEmitter();

  @Output()
  TryRemoveAllEventsBasedOnFilter = new EventEmitter();

  calendarFilter = CalendarFilter.All;

  TaskTypes = TaskTypes;

  chosenTask: Task;

  chosenRTT: ResourceTaskTime;

  listToShow: string = '1a';

  isDragging: boolean;

  doWork: boolean;

  viewNames = ViewNames;

  viewName: number;

  showForAllJobs = "Alle sager";
  showForAllTasks = "Hele Sagen";

  @Input()
  calendarTask: Task;

  @Input()
  maxResourceNameLength: number;


  duration = 7;

  eventHours: number;

  StartDate: Date = new Date();

  EndDate: Date = new Date();

  dummyStart;
  dummyEnd;


  public startDatePickerOptions: IMyDpOptions;
  public endDatePickerOptions: IMyDpOptions;


  dynamicSlotWidth: number = 10;

  currentView = 'allDayWeekTimeline';

  dateChanged: boolean = true;

  stateChange: boolean = false;

  hasCheckedForExpanded: boolean = false;

  loading: boolean = false;

  @Input()
  set ChosenTask(task: Task) {
    if (task != null) {

      if (this._ChosenTask == null || task.No != this._ChosenTask.No) {

        this.dateChanged = true;
        this.currentView = "dateRangeTimeLine";
        let s = new Date(task.start);
        s.setDate(new Date(task.start).getDate() - 3);
        this.StartDate = s;
        let e = new Date(task.end);
        e.setDate(new Date(task.end).getDate() + 3);
        this.EndDate = e;
      }


      this._ChosenTask = task;
      this.setOptionsData();
      this.rerenderCalendar(this.calendar);
    }
  }

  constructor(private timePlanService: TimeplanService, private taskservice: TaskService, private resourceTaskTimeService: ResourceTaskTimeService) {
  }


  ngOnInit() {
    this.chosenTask = new Task();
    this.chosenRTT = new ResourceTaskTime();
    this.isDragging = false;

    this.StartDate = new Date(this.StartDate.toDateString());
    this.EndDate.setDate(new Date().getDate() + 6);
    this.EndDate = new Date(this.EndDate.toDateString());


    this.setOptionsData();
  }

  setOptionsData() {
    this.setDuration();
    this.dummyStart = {
      date: {
        year: this.StartDate.getFullYear(),
        month: this.StartDate.getMonth() + 1,
        day: this.StartDate.getDate()
      }
    };
    this.dummyEnd = {
      date: {
        year: this.EndDate.getFullYear(),
        month: this.EndDate.getMonth() + 1,
        day: this.EndDate.getDate()
      }
    };

    this.startDatePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: this.dummyEnd.date, end: {year: 2055, month: 11, day: 20}}],
    };
    this.endDatePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: {year: 1980, month: 11, day: 20}, end: this.dummyStart.date}],
    };
  }

  setDuration() {
    let diff = Math.abs(this.getTimeOfDate(this.StartDate) - this.getTimeOfDate(this.EndDate));
    this.duration = Math.ceil(diff / (1000 * 3600 * 24)) + 1;
  }

  getTimeOfDate(date: Date): number {
    let s = moment(date).format(environment.START_DATETIME_FORMAT);
    let d = new Date(s);
    return d.getTime();
  }

  getTasks(taskPageModel: TaskPageModel) {
    taskPageModel.CalendarFilter = this.calendarFilter;

    if (this.ChosenJob != null && this.ChosenJob.No != this.showForAllJobs)
      taskPageModel.JobNo = this.ChosenJob.No;

    if (this.calendarTask != null)
      taskPageModel.TaskNo = this.calendarTask.No;

    this.refreshCurrentTaskListEmitter.emit(taskPageModel);

  }

  createTimePlanForEmployee(origionalTaskObject: any) {
    return this.timePlanService.createTimePlan({
      TaskRef: origionalTaskObject.TaskRef,
      ResourceRef: origionalTaskObject.resourceId,
      start: origionalTaskObject.start,
      end: origionalTaskObject.end
    });
  }

  updateTimePlanOnChange(timePlanNo: string, startTime: string, endTime: string, resourceId: string) {
    let obj: ResourceTaskTime = {TimePlanRef: timePlanNo, start: startTime, end: endTime, ResourceRef: resourceId};
    this.updateTimePlanEmitter.emit(obj);
  }

  updateTimePlanWithRef(timePlanNo: string, startTime: string, endTime: string, resourceId: string, origResourceId: string, taskRef: string) {
    let obj: ResourceTaskTime = {
      TimePlanRef: timePlanNo,
      start: startTime,
      end: endTime,
      ResourceRef: resourceId,
      OrigResourceRef: origResourceId,
      TaskRef: taskRef
    };
    this.updateTimePlanEmitter.emit(obj);
  }

  updateRTT(rtt: ResourceTaskTime) {
    this.loading = true;
    let obj: ResourceTaskTime = {
      TimePlanRef: rtt.TimePlanRef,
      start: rtt.start,
      end: rtt.end,
      ResourceRef: rtt.ResourceRef,
      TaskRef: rtt.TaskRef,
      Comment: rtt.Comment,
      IsApproved: rtt.IsApproved
    };
    this.updateRTTEmitter.emit(obj);
  }


  changeJobTask(taskRef: string) {
    this.loading = true;
    this.changeJobTaskEmitter.emit(taskRef);
  }

  removeEmployeeTimePlan(timePlanNo: string, taskGuid: string, employeeNo: string) {
    let obj: ResourceTaskTime = {TimePlanRef: timePlanNo, TaskRef: taskGuid, ResourceRef: employeeNo};
    this.removeEmpTimePlanEmitter.emit(obj);
  }

  updateTask(task: Task) {
    this.loading = true;
    this.updateTaskEmitter.emit(task);
  }


  rerenderCalendar(calendar: Calendar) {
    var self = this;


    setTimeout(function () {
      if (!self.firstRun) {
        //self.currentView = $('#calendar').fullCalendar('getView').type;

      }
      // Setting startDate is not necessary because we only destroy (reset) the calendar when a date is chanegd.
      if (!self.dateChanged) {

        self.dateChanged = false;

        self.doWork = false;
        if (calendar != null) {
          self.doWork = true;
          if (self.doWork == true) {
            $('#calendar').fullCalendar('removeEvents');
          }
          if (self.doWork == true) {
            $('#calendar').fullCalendar('addEventSource', calendar.ResourceTaskTimes);
            self.doWork = false;
          } else {
            self.rerenderCalendar(calendar);
          }
        }
      } else {

        $('#calendar').fullCalendar('destroy');
        $('#calendar').fullCalendar('render');
        self.dateChanged = false;
      }
      self.loading = false;
    }, 300);


  }


  setStartDate(event: IMyDateModel) {

    this.dateChanged = true;
    this.StartDate = event.jsdate;

    this.setOptionsData();
    this.rerenderCalendar(this.calendar);

  }

  setEndDate(event: IMyDateModel) {

    this.dateChanged = true;
    this.EndDate = event.jsdate;

    this.setOptionsData();
    this.rerenderCalendar(this.calendar);

  }


  openTaskModal(task: Task) {
    this.chosenTask = Object.assign({}, task);
    $('#myModal').modal('show');
    //this.getTaskOperation.subscribe(x => {this.chosenTask = x; $('#myModal').modal('show');});
  }

  openRTTModal(rtt: ResourceTaskTime) {
    this.resourceTaskTimeService.GetRTTWithGlobalDates(rtt.TaskRef, rtt.ResourceRef, rtt.TimePlanRef).subscribe(newRtt => {

      this.chosenRTT = Object.assign({}, newRtt);
      $('#myRTTModal').modal('show');

    })

  }

  SetApprovedOnCurrentEvents(isApproved: boolean) {
    $('.btn-with-tooltip').blur();
    this.loading = true;
    let approveModel = new ApproveEventsModel();
    approveModel.StartDate = this.StartDate;
    approveModel.EndDate = this.EndDate;
    approveModel.JobNo = this.ChosenJob.No != this.showForAllJobs ? this.ChosenJob.No : null;
    approveModel.TaskGuid = this.ChosenTaskRef != this.showForAllTasks ? this.ChosenTaskRef : null;
    approveModel.ResourceNos = this.employees.map(({No}) => No);
    approveModel.IsApproved = isApproved;


    this.SetApprovedOnCurrentEventsEmitter.emit(approveModel);
  }


  RemoveAllEventsBasedOnFilter() {
    this.loading = true;
    $('.btn-with-tooltip').blur();
    let chosenTask = this.JobTasks.filter(x => x.Task_GUID == this.ChosenTaskRef)[0];

    if(confirm("Er du sikker på at du vil fjerne alle opgaver for \n" +
      (!!chosenTask ? ("Sag        : " + this.ChosenJob.No + "\nOpgave : " + chosenTask.Title) : ("Sag: " + this.ChosenJob.No)))) {


      let eventsModel = new ApproveEventsModel();
      eventsModel.JobNo = this.ChosenJob.No;
      eventsModel.TaskGuid = this.ChosenTaskRef != this.showForAllTasks ? this.ChosenTaskRef : null;

      this.TryRemoveAllEventsBasedOnFilter.emit(eventsModel);
    }
  }


  InitJS() {
    let self = this;
    $('#calendar').fullCalendar({
      schedulerLicenseKey: environment.SCHEDULER_TOKEN,
      plugins: ['resourceTimeline'],
      locale: "da",
      timeZone: 'utc',
      defaultView: self.currentView,
      aspectRatio: 1.6,
      droppable: true, // this allows things to be dropped onto the calendar !!!
      dragRevertDuration: 0,
      lazyFetching: true,
      minTime: "07:00:00",
      maxTime: "18:00:00",
      handleWindowResize: true,
      weekNumbers: true,
      resourceAreaWidth: (self.maxResourceNameLength * 11).toString() + 'px',
      contentHeight: 'auto',
      defaultDate: self.StartDate,

      subTitle: 'Ansatte',

      // ResourceGroup settings
      resourcesInitiallyExpanded: true,
      resourceGroupField: 'groupId',

      views: {
        allDayWeekTimeline: {
          type: 'timelineMonth',
          slotWidth: 44,
          dateAlignment: 'month',
        },
        yearTimeline: {
          slotWidth: 4,
          buttonText: "År",
          slotLabelFormat: [
            'MMMM', // top level of text
            '|'
          ],
          type: 'timelineYear',
        },
        dateRangeTimeLine: {
          slotWidth: self.dynamicSlotWidth,

          duration: {days: self.duration},
          type: 'timelineMonth',
          buttonText: 'Datointerval',
          slotLabelInterval: {days: 1},
          allDay: true,
        }
      },
      resourceLabelText: 'Medarbejdere',
      header: {
        left: 'prev,next today, downloadPdfBtn',
        center: 'title',
        right: 'timelineWeek,allDayWeekTimeline,yearTimeline,dateRangeTimeLine'
      },


      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        dow: [1, 2, 3, 4, 5], // Monday - Thursday

        start: '07:00', // a start time (10am in this example)
        end: '17:00', // an end time (6pm in this example)
      },
      resources: this.employees,
      events: this.calendar.ResourceTaskTimes,
      navLinks: true,
      // other options go here...

      /*customButtons: {
        downloadPdfBtn: {

          text: 'Download som PDF',
          click: function () {
            if (self.currentView == 'dateRangeTimeLine') {
              let expandedGroups = self.resourceGroups.filter(element => element.isExpanded);

              let events = $('#calendar').fullCalendar('clientEvents', function (e) {
                return e.GUID != null && (e.start >= self.StartDate && e.start <= self.EndDate || e.end >= self.StartDate && e.end <= self.EndDate)
                  && expandedGroups.filter(eg => eg.children.filter(child => child.resource.No == e.resourceId)[0] != null)[0] != null
              });
              self.pdfExportManager.exportPDF_Schedule(self.ChosenJob, events, self.StartDate, self.EndDate);
            }
          }
        }
      },*/


      viewRender: function (view, element) {

        // Automatically sets the minimum height of the view content to the current height, so the view doesnt jump when data is refreshed and rendered.
        $('.calendarDiv').css('min-height', $('.calendarDiv').css('height') - 10);


        if (view.type == "dateRangeTimeLine" && self.currentView != view.type && self.stateChange) {
          self.stateChange = false;
          self.currentView = "dateRangeTimeLine";
          //self.StartDate = new Date(self.ChosenTask.start);

          self.dateChanged = true;
          self.rerenderCalendar(self.calendar);


        }
        if (view.type != "dateRangeTimeLine") {
          self.stateChange = true;
        }
        if (view.type == "month") {
          // Start and end date is both wrong compared to the choosen month. The chosen month is in between start and end, for some reason....
          let difference = view.end - view.start;
          let newStart = (view.start + (difference / 2));
          console.log(moment(newStart).format(environment.FULL_DATETIME_FORMAT_DANISH));

          $('#calendar').fullCalendar('changeView', 'allDayWeekTimeline');
          $('#calendar').fullCalendar('gotoDate', newStart);
        } else if (view.type == "basicDay") {
          // There is no timeline day in our version.. Therefor just reload current view, instead of basicDay default view.

          if (self.currentView == "dateRangeTimeLine") {
            // Fix bug where DatoInterval calendar changes date when day clicked.
            $('#calendar').fullCalendar('gotoDate', self.StartDate);
          }
          $('#calendar').fullCalendar('changeView', self.currentView);
        }


        if (view.name != self.viewNames[self.viewNames.timelineWeek]) {
          self.viewName = self.viewNames.allDayWeekTimeline;
        } else {
          self.viewName = self.viewNames.timelineWeek;
        }

        //else if(view.name == self.viewNames[self.viewNames.timelineWeek]){
        //  self.viewName = self.viewNames.timelineWeek;
        //}

        if ($('#calendar').fullCalendar('getView').type != undefined) {

          self.currentView = $('#calendar').fullCalendar('getView').type;

        } else {

        }


      },


      // This function is called when an external event is dropped
      drop: function (date, jsEvent, ui, resourceId) {
        let CreateAllDayEvent = function () {
          // set the date to Danish timezone
          let startDate = date.format(environment.START_DATETIME_FORMAT);

          copiedEventObject.start = startDate;


          copiedEventObject.start = self.calendarTask != null && copiedEventObject.start < self.calendarTask.start ?
            self.calendarTask.start : startDate;


          copiedEventObject.start =
            self.calendarTask != null && copiedEventObject.start > self.calendarTask.end ? self.calendarTask.end : copiedEventObject.start;


          copiedEventObject.end = copiedEventObject.start;
          self.createTimePlanForEmployee(copiedEventObject).subscribe(
            timePlanNo => {
              placeEventInCalendar(copiedEventObject, timePlanNo),
                $('.tooltipDropEvent').remove();
            });
        };


        // retrieve the dropped element's stored Event Object
        var originalEventObject = $(this).data('eventObject');
        originalEventObject.resourceId = resourceId;


        // we need to copy it, so that multiple events don't have a reference to the same object
        var copiedEventObject = $.extend({}, originalEventObject);

        // assign it the date that was reported
        copiedEventObject.start = date;

        var tooltip = '<div class="tooltipDropEvent panel panel-default" align="center" ' +
          'style="width:260px;height:160px;position:absolute;' +
          'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
          '><div class="panel-heading"><strong>' + copiedEventObject.title + '</strong>' +
          '<button type="button" class="close cancelAction" data-dismiss="modal">&times;</button></div>' +
          '<div class="panel-body">' +
          '<b>Opret opgave for</b>' +
          '<br>' +
          '<br>' +
          '<button id="AllDayEvent" class="btn btn-default">En hel dag</button>' + ((self.viewName == self.viewNames.timelineWeek) ?
            ' | ' +
            '<input id="eventHourInput" class="panel" style="width: 30px; height: 30px; margin-left: 0px; margin-bottom: 0px; border: 1px solid lightgrey; text-align: center;" type="number" value="2" ngModel="{{eventHours}}" >' +
            '<button id="HourBasedEvent" class="btn btn-default" style="margin-left: 0px;">Antal timer</button>' : '') +
          '</div>' +
          '</div>';
        if (self.viewName == self.viewNames.timelineWeek) {
          $("body").append(tooltip);
          $(this).css('z-index', 10000);
          $('.tooltipDropEvent').fadeIn('500');
          $('.tooltipDropEvent').fadeTo('10', 1.9);
          $('.tooltipDropEvent').css('top', jsEvent.pageY + -175);
          $('.tooltipDropEvent').css('left', jsEvent.pageX + -120);
        } else {
          // set the date to Danish timezone
          self.loading = true;
          CreateAllDayEvent();
        }


        $('#AllDayEvent').click(function () {
          self.loading = true;

          // set the date to Danish timezone
          CreateAllDayEvent();
        });
        $('#HourBasedEvent').click(function () {
          self.loading = true;
            date.format();

            if (self.calendarTask != null)
              moment(self.calendarTask.end).format(environment.FULL_DATETIME_FORMAT);

            if (self.calendarTask != null && date.format() > moment(new Date(self.calendarTask.end).setDate(new Date(self.calendarTask.end).getDate() + 1)).format(environment.FULL_DATETIME_FORMAT) || self.calendarTask != null && date.format() < self.calendarTask.start) {
              $('.tooltipDropEvent').remove();
            } else if (date.format(environment.END_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_END) {

              let hours = parseInt($('#eventHourInput').val());

              let end = new Date(date.format());
              let e = moment(end.setHours(end.getHours() + hours));

              copiedEventObject.end = e.format();
              copiedEventObject.start.format();

              self.createTimePlanForEmployee(copiedEventObject).subscribe(
                timePlanNo => {
                  placeEventInCalendar(copiedEventObject, timePlanNo),
                    $('.tooltipDropEvent').remove();
                });
            } else {
              $('.tooltipDropEvent').remove();
            }
          }
        );

        $('.cancelAction').click(function () {
          $('.tooltipDropEvent').remove();
        });
      },


      // This function is called when a event is dropped inside the calendar
      eventDrop: function (event, delta, revertFunc, jsEvent) {

        if(!!jsEvent) {
          self.loading = true;
          if (jsEvent.shiftKey) {

            let e = moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT) != moment(new Date(event.end)).format(environment.START_DATETIME_FORMAT) ? moment(new Date(event.end).setDate( new Date(event.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT) : event.end;
            event.end = e;


            self.createTimePlanForEmployee( event).subscribe(
              timePlanNo => {
                //placeEventInCalendar(event, timePlanNo)
              });
          } else {
            event.eventStartEditable = false;

            self.updateTimePlanWithRef(event.TimePlanRef, event.start, event.end, event.resourceId, event.OrigResourceRef, event.TaskRef);
            event.OrigResourceRef = event.resourceId;
            self.setDragging(false);
          }
        }
      },

      // This funtion is called when a event is resized
      eventResize: function (event, delta, revertFunc) {
        self.loading = true;
        self.updateTimePlanOnChange(event.TimePlanRef, event.start, event.end, event.resourceId);
      },

      eventDragStart: function (event, jsEvent, ui, view) {
        self.setDragging(true);
      },

      // This function is called when a event is dropped on the external event list.
      eventDragStop: function (event, jsEvent, ui, view) {
        if (jsEvent != null && event != null) {
          if (isEventOverDiv(jsEvent.clientX, jsEvent.clientY)) {

            var tooltip = '<div class="tooltipDeleteEvent panel panel-default" align="center" ' +
              'style="width:260px;height:260px;position:absolute;' +
              'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
              '><div class="panel-heading"><strong>' + 'Fjern tid?' + '</strong>' +
              '<button type="button" id="cancelActionBtn" class="close cancelAction" data-dismiss="modal">&times;</button></div>' +
              '<div class="panel-body">' +
              '<p>' + 'Er du sikker på at du vil slette tid for ' + '</p><pre>' + event.resourceId + ' </pre>' + '<p>På opgave </p><pre>' + event.title + '</pre>' +
              '<button id="DeleteEventBtn" class="btn btn-danger">Slet</button>' +
              '<button id="CancelDeleteBtn" class="btn btn-default cancelAction" style="margin-left: 20px;">Fortryd</button>' +
              '</div>' +
              '</div>';
            $("body").append(tooltip);
            $(this).css('z-index', 10000);
            $('.tooltipDeleteEvent').fadeIn('500');
            $('.tooltipDeleteEvent').fadeTo('10', 1.9);
            $('.tooltipDeleteEvent').css('top', jsEvent.pageY + -275);
            $('.tooltipDeleteEvent').css('left', jsEvent.pageX + -120);

            $('#DeleteEventBtn').click(function () {

              $('#calendar').fullCalendar('removeEvents', event._id);
              self.loading = true;
              self.removeEmployeeTimePlan(event.TimePlanRef, event.TaskRef, event.resourceId);
              $('.tooltipDeleteEvent').remove();
            });
            $('#CancelDeleteBtn').click(function () {
              $('.tooltipDeleteEvent').remove();
            });

            $('.cancelAction').click(function () {
              $('.tooltipDeleteEvent').remove();
            });

          }
        } else {
          self.rerenderCalendar(self.calendar);
        }
        ;
        self.setDragging(false);
      },

      eventRender: function (event, element) {
        let style = 'font-family: Helvetica; overflow: hidden;display:block; height: auto; border: 1px solid #cccccc; background-color: whitesmoke; border-radius: 3px; padding-top: 5px; padding-bottom: 5px;';
        let yPosition = -120;
        let xPositionMultiplier = 1;


        element.mouseenter(function (e) {

          if (self.isDragging == false) {
            if (event.rendering == 'background') {
              yPosition = 50;
              xPositionMultiplier = 0.5;


              let events = $('#calendar').fullCalendar('clientEvents', function (e) {
                return e.GUID != null && e.ResourceRef == event.ResourceRef && e.start >= event.start && e.start < event.end && e.end > event.start;// && e.end <= event.end;
              });
              let tooltip = '<div class="tooltipevent panel panel-default" align="center" ' +
                'style="width:260px;height:auto;position:absolute;' +
                'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
                '>';

              events.forEach(ev => {
                let ted = new Date(ev.end);
                ted.setDate(new Date(ev.end).getDate() - 1);

                tooltip += '<div class="panel-heading"><strong>' + ev.Title + '</strong></div><div class="panel-body">' +
                  (ted < new Date(ev.start) ?
                    ('<p style="' + style + '+">' + moment(new Date(ev.start)).format(environment.START_DATETIME_FORMAT_DANISH) + '<br /><strong>Fra</strong> ' + moment.utc(new Date(ev.start)).format(environment.END_DATETIME_FORMAT) + ' <strong>Til</strong> ' + moment.utc(new Date(ev.end).setDate(new Date(ev.end).getDate())).format(environment.END_DATETIME_FORMAT)) :
                    ('<p style="' + style + '+">' + moment(new Date(ev.start)).format(environment.START_DATETIME_FORMAT_DANISH) + ((moment(new Date(ev.start)).format(environment.START_DATETIME_FORMAT_DANISH) != moment(new Date(ev.end).setDate(new Date(ev.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)) ? ('<strong> - </strong>' + moment(new Date(ev.end).setDate(new Date(ev.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)) : ""))) +
                  '</p>' +
                  '<p style="' + style + '+"><strong>Kunde:</strong> ' + ev.Customer + '</pre>' +
                  '<p style="' + style + '+"><strong>Planlagte timer:</strong> ' + ev.CalcEstimate + ' timer</pre>' +
                  '<p style="' + style + '+"><strong>Beskrivelse:</strong> ' + ev.Job_Description + ' </p>' +
                  '</div>';
              });
              tooltip += '</div>';

              $("body").append(tooltip);
            } else {
              let ted = new Date(event.end);
              ted.setDate(new Date(event.end).getDate() - 1);

              let tooltip = '<div class="tooltipevent panel panel-default" align="center" ' +
                'style="width:260px;height:auto;position:absolute;' +
                'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
                '>' +
                '<div class="panel-heading"><strong>' + event.Title + '</strong></div><div class="panel-body">' +
                (ted < new Date(event.start) ?
                  ('<p style="' + style + '+">' + moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT_DANISH) + '<br /><strong>Fra</strong> ' + moment.utc(new Date(event.start)).format(environment.END_DATETIME_FORMAT) + ' <strong>Til</strong> ' + moment.utc(new Date(event.end).setDate(new Date(event.end).getDate())).format(environment.END_DATETIME_FORMAT)) :
                  ('<p style="' + style + '+">' + moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT_DANISH) + ((moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT_DANISH) != moment(new Date(event.end).setDate(new Date(event.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)) ? ('<strong> - </strong>' + moment(new Date(event.end).setDate(new Date(event.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)) : ""))) +
                '</p>' +
                '<p style="' + style + '+"><strong>Kunde:</strong> ' + event.Customer + '</pre>' +
                '<p style="' + style + '+"><strong>Planlagte timer:</strong> ' + event.CalcEstimate + ' timer</pre>' +
                '<p style="' + style + '+"><strong>Beskrivelse:</strong> ' + event.Job_Description + ' </p>' +
                '</div></div>';
              $("body").append(tooltip);
            }

            $(this).mouseover(function (e) {
              $(this).css('z-index', 10000);
              $('.tooltipevent').fadeIn('500');
              $('.tooltipevent').fadeTo('10', 1.9);
            }).mousemove(function (e) {
              $('.tooltipevent').css('top', e.pageY + (-parseInt($('.tooltipevent').css('height'), 10) * xPositionMultiplier) + -15);
              $('.tooltipevent').css('left', e.pageX + yPosition);
            });

          }
        });
        element.mouseleave(function (e) {
          $(this).css('z-index', 8);
          $('.tooltipevent').remove();
        });


        element.bind('dblclick', function () {
          self.openRTTModal(event);
        });
        if (event.Icon) {
          element.find(".fc-content").prepend("<i style='color: #8b0000;  text-shadow: 0px 0px 3px #FFFFFF; margin-left: 3px;' class='fa fa-" + event.Icon + "'></i>");
        }
      },
      eventAfterAllRender: function (view) {

        // First run - set Expanded on group based on NAV data.
        if (self.resourceGroups == null)
          self.resourceGroups = view.rowHierarchy.children;

        if(!self.hasCheckedForExpanded)
        {
          for(let i = 0; i < self.resourceGroups.length; i++) {
            let resourceGroup = self.resourceGroups[i];

            let emp = self.employees.filter(emp => emp.groupId === resourceGroup.groupValue)[0];

            resourceGroup.isExpanded = emp.Is_Expanded;
          }
          self.hasCheckedForExpanded = true;
        }


        // Update resourceGroups when the ResourceGroup expander is clicked
        $('.fc-expander').bind('click', function () {

          self.resourceGroups = view.rowHierarchy.children;

        });
        if (!!view.rowHierarchy) {
          // collapse the groups when based on the resourceGroups
          for (let x = 0; x < view.rowHierarchy.children.length; x++) {
            let thisRow = view.rowHierarchy.children[x];

            let savedRow = self.resourceGroups.filter(row => row.groupValue == thisRow.groupValue)[0];

            if (savedRow != null && !savedRow.isExpanded && thisRow.isExpanded) {
              thisRow.collapse();
            }
          }
          self.resourceGroups = view.rowHierarchy.children;
        }

        if(!!$('.tooltipevent'))
        $('.tooltipevent').remove();
      },


      eventMouseover: function (calEvent, jsEvent) {

      }
    });


    if (this.firstRun && this.calendarDate != null) {
      $('#calendar').fullCalendar('gotoDate', this.calendarDate);
      //this.firstRun = false;
    }

    // Checks if the dragged event is over the external event list.
    let isEventOverDiv = function (x, y) {

      var external_events = $('#external-events');
      var offset = external_events.offset();
      offset.right = external_events.width() + offset.left;
      offset.bottom = external_events.height() + offset.top;

      // Compare
      if (x >= offset.left
        && y >= offset.top
        && x <= offset.right
        && y <= offset.bottom) {
        return true;
      }
      return false;
    };

    var placeEventInCalendar = function (copiedEventObject, timeplanNo) {

      copiedEventObject.TimePlanRef = timeplanNo;
      copiedEventObject.ResourceRef = copiedEventObject.resourceId;
      copiedEventObject.OrigResourceRef = copiedEventObject.resourceId;
      // render the event on the calendar
      // the last `true` argument determines if the event "sticks" (http://arshaw.com/fullcalendar/docs/event_rendering/renderEvent/)
      $('#calendar').fullCalendar('renderEvent', copiedEventObject, true);

      // is the "remove after drop" checkbox checked?
      if ($('#drop-remove').is(':checked')) {
        // if so, remove the element from the "Draggable Events" list
        $(this).remove();
      }
    };

    // This function is called on every external event in the list.
    $('#external-events .fc-event').each(function () {

      // create an Event Object (http://arshaw.com/fullcalendar/docs/event_data/Event_Object/)
      // it doesn't need to have a start or end

      var eventObject = {
        title: $.trim($(this).text()), // use the element's text as the event title
        TaskRef: $(this).children('.taskRef').val(),
        stick: false
      };

      // store the Event Object in the DOM element so we can get to it later
      $(this).data('eventObject', eventObject);

      // make the event draggable using jQuery UI
      $(this).draggable({
        zIndex: 999,
        revert: true,      // will cause the event to go back to its
        revertDuration: 0  //  original position after the drag
      });
    });


  };

  toggleList(toggledList) {
    this.listToShow = toggledList;
  }

  setDragging(value: boolean) {
    this.isDragging = value;
  }


  pdfExporter() {

    /*const elementToPrint = $('.fc-view-container');
    elementToPrint.css("background-color", "white");
    let w = elementToPrint.width();
    let s = (w + 30) + "px";
    elementToPrint.css("width", s);


    var margins = {
      top: 0,
      bottom: 60,
      left: 20,
      width: 522
    };
    //The html element to become a pdf
    var no = this.ChosenJob.No + " - " + this.ChosenJob.Bill_to_Name + " - " + this.ChosenJob.Description;
    const pdf = new jsPDF('l', 'pt', 'a4');
    pdf.text('' + no, pdf.internal.pageSize.width / 2, 40, 0, 0, 'center');
    pdf.internal.scaleFactor = 1.5;
    pdf.text
    pdf.addHTML(elementToPrint, margins.left, 50, '', () => {
      pdf.save('gantkort.pdf');
      elementToPrint.css("width", (w + "px"));
  });*/

  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/scheduler/scheduler-view.component.ts